import React, { ReactNode } from 'react';

import { mergeClassNameStrings } from '@consumer-frontend/nc-utils';

import { NcAlert } from '../NcAlert';
import { NcSupportNumberLink } from '../NcSupportNumberLink';

export type NcErrorPropsT = {
  message: ReactNode;
  children?: ReactNode;
  className?: string;
  displaySupportText?: boolean;
  header?: ReactNode;
};
export type NcErrorT = React.FC<NcErrorPropsT>;

export const NcError: NcErrorT = ({
  header,
  message,
  children,
  className,
  displaySupportText,
}) => {
  return (
    <div className={mergeClassNameStrings('nc-error col-md-6 mx-auto', className)}>
      <NcAlert
        dismissible={false}
        variant="warning"
        header={header}
      >
        {message}
      </NcAlert>

      <p className="support-message text-center mb-1">
        {children}
      </p>

      {displaySupportText && (
        <p className="support-message text-center">
          Please call our Customer Support Team at{' '}
          <NcSupportNumberLink />{' '}
          or try again later.
        </p>
      )}
    </div>
  );
};
